module.exports = __webpack_public_path__ + "static/media/upcoming_exam.e936522a.svg";